import { Component, ContentChild } from '@angular/core';

import { PuiTabsComponent } from '../tab/index';

@Component({
  selector: 'pui-portlet-body',
  templateUrl: 'portlet-body.component.html'
})
export class PuiPortletBodyComponent {
  @ContentChild(PuiTabsComponent) tabset: PuiTabsComponent;
}
